module.exports = __webpack_public_path__ + "6c4a0dbc/img/placeholder.888fcd0b.svg";